import theme from "assets/theme";
import React, { useCallback, useMemo, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import CustomModal from "webComponentsFormElements/CustomModal.component";
import SearchBar from "webComponentsFormElements/inputs/SearchBar.component";
import PressableContainer from "webComponentsFormElements/PressableContainer.component";

const classes = StyleSheet.create({
  marginTop15: {
    marginTop: 15,
  },
  smallText: {
    fontSize: 12,
  },
  checkmarkText: {
    fontSize: 18,
  },
  associationName: {
    fontSize: 14,
    color: theme.color.backgroundText,
  },
  selectionModal: {
    width: "70%",
    maxWidth: "800px",
    maxHeight: "80vh",
  },
  selectionRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 4,
    paddingVertical: 8,
    justifyContent: "space-between",
    backgroundColor: theme.color.background,
    marginVertical: 2,
    borderRadius: 4,
  },
});

export default function PersonSelectionModal({
  open,
  onClose,
  personList,
  selectedPersonIds,
  onTogglePerson,
  organizationColor,
  title = "Select Persons",
}) {
  const [searchText, setSearchText] = useState("");

  const handleClose = useCallback(() => {
    setSearchText("");
    onClose();
  }, [onClose]);

  const togglePerson = useCallback(
    (personId) => {
      onTogglePerson(personId);
    },
    [onTogglePerson],
  );

  const filteredPersons = useMemo(() => {
    return (
      personList
        ?.filter((person) =>
          `${person.firstName} ${person.lastName}`
            .toLowerCase()
            .includes(searchText.toLowerCase()),
        )
        .sort((a, b) => a.lastName.localeCompare(b.lastName)) || []
    );
  }, [personList, searchText]);

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      title={title}
      style={classes.selectionModal}
      scroll
    >
      <View>
        <SearchBar value={searchText} onChangeText={setSearchText} />
        <View style={classes.marginTop15}>
          {filteredPersons.map((person) => (
            <PressableContainer
              key={person.personId}
              style={classes.selectionRow}
              onPress={() => togglePerson(person.personId)}
            >
              <View>
                <Text style={classes.associationName}>
                  {person.firstName} {person.lastName}
                </Text>
                <Text
                  style={[
                    classes.associationName,
                    classes.smallText,
                    { color: theme.color.mediumGrey },
                  ]}
                >
                  {person.position || "No position"} • {person.email}
                </Text>
              </View>
              <Text
                style={[classes.checkmarkText, { color: organizationColor }]}
              >
                {selectedPersonIds.includes(person.personId) ? "✓" : "+"}
              </Text>
            </PressableContainer>
          ))}
        </View>
      </View>
    </CustomModal>
  );
}
